import { styled } from '@mui/material/styles';

import { VAR_AREA_TOP } from '@mopla/constants';

export const SwiperWrapper = styled('div')(({ theme }) => ({
	flexGrow: 1,
	overflow: 'hidden',

	'--swiper-pagination-bottom': '24px',

	'& .swiper-pagination-bullet': {
		backgroundColor: theme.palette.neutral[50],
		opacity: 0.2,
	},

	'& .swiper-pagination-bullet-active': {
		backgroundColor: theme.palette.neutral[0],
		opacity: 1,
	},
}));

export const SlideRoot = styled('div')(({ theme }) => ({
	boxSizing: 'border-box',
	height: '100%',

	'& .image': {
		position: 'absolute',
		zIndex: -1,
	},
}));

export const SlideContentWrapper = styled('div')(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-between',
	height: '100%',
	paddingInline: 24,
	paddingBottom: 48,
	boxSizing: 'border-box',
}));

export const LogoWrapper = styled('div')(({ theme }) => ({
	paddingTop: `max(${VAR_AREA_TOP}, 24px)`,
	alignSelf: 'center',
}));

export const MoplaLogoImgStyled = styled('img')(() => ({
	gridArea: 'logo',
	alignSelf: 'center',
	height: 74,
}));
